import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=261c24d8"
import script from "./Job.vue?vue&type=script&lang=js"
export * from "./Job.vue?vue&type=script&lang=js"
import style0 from "./Job.vue?vue&type=style&index=0&id=261c24d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports